module.exports = __webpack_public_path__ + "img/greyAssign.21c36c6a.svg";